import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const ConsultationHistoryRating = React.lazy(() =>
  import('../../views/ConsultationHistoryRating/index')
);

const params = [];

const ConsultationHistoryRatingRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <ConsultationHistoryRating />
      </Layout>
    </RouteParameter>
  );
};

ConsultationHistoryRatingRoute.propTypes = {};

ConsultationHistoryRatingRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ConsultationHistoryRatingRoute);
